<template>
  <div class="orderCenter-right">
    <div class="head">
      <h3>我的订单</h3>
      <div>
        <el-dropdown @command="handleCommand">
    <el-button type="primary" >
      {{orderName}}<i class="el-icon-arrow-down el-icon--right"></i>
    </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command=6>全部订单</el-dropdown-item>
        <el-dropdown-item command=0>待审核</el-dropdown-item>
        <el-dropdown-item command=1>已审核</el-dropdown-item>
        <el-dropdown-item command=2>已发货</el-dropdown-item>
        <el-dropdown-item command=3>已完成</el-dropdown-item>
        <el-dropdown-item command=4>已取消</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dropdown @command="handleCommands">
        <el-button type="primary">
         {{payName}}<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
          <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command=6>全部订单</el-dropdown-item>
              <el-dropdown-item command=0>待付款</el-dropdown-item>
              <el-dropdown-item command=1>已付款</el-dropdown-item>
              <el-dropdown-item command=2>已退款</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        <input type="text" placeholder="产品名称/订单号" v-model="keywords" @keyup.enter="dataListFn"/>
        <button class="search" @click="dataListFn">查询</button>
      </div>
    </div>
    <div class="main">
      <Tables :list="this.mailList"></Tables>
      <div class="person-tag__list-pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pageIndex"
            :page-sizes="[ 5,10, 20, 30]"
            background
            layout="total, sizes , prev, pager, next"
            :total="total"
            >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
currentPageData
<script>
import Tables from "./table";
export default {
  data() {
    return {
      mailList: [], //总数据list
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      keywords:'',
      orderName:'订单状态',
      payName:'付款状态',
      orderStatus:['待审核','已审核','已发货','已完成','已取消'],
      payStatus:['待付款','已付款','已退款'],
      status:'',
      payaStatus:''
    };
  },
  components: {
    Tables,
  },
  methods: {
    handleCommand(commend){
      if(commend == 6){
        this.status = '',
        this.orderName = '订单状态'
      }else{
         this.status = +commend
         if(this.status == 0){
            this.orderName = '待审核'
          }else if(this.status == 1){
            this.orderName = '已审核'
          }else if(this.status == 2){
            this.orderName = '已发货'
          }else if(this.status == 3){
            this.orderName = '已完成'
          }else if(this.status == 4){
            this.orderName = '已取消'
          }
      }
      this.dataListFn()
    },
    handleCommands(commend){
       if(commend == 6){
        this.payaStatus = '',
        this.payName = '订单状态'
      }else{
         this.payaStatus = +commend
         if(this.payaStatus == 0){
            this.payName = '待付款'
          }else if(this.payaStatus == 1){
            this.payName = '已付款'
          }else if(this.payaStatus == 2){
            this.payName = '已退款'
          }
      }
      this.dataListFn()
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.dataListFn();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.dataListFn();
    },
    handleChange(value) {},
    dataListFn() {
      this.$api.order.orderList({
        keyword:this.keywords,
        status:this.status,
        pay_status:this.payaStatus,
        page: this.pageIndex,
        limit:this.pageSize
      }).then((res) => {
        this.total = res.count
        this.mailList = res.data;
        this.keywords =''
        });
    }
  },
  created() {
    this.dataListFn();
  }
};
</script>

<style lang="less" scoped>
*{
font-size: 14px;
}

  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #A52A2A !important;
  }
  /deep/.person-tag__list-pagination {
    text-align: center;
    margin-top: 20px;
    span{
      font-weight: 600;
    }
  }

.orderCenter-right {
  width: 876px;
  .head {
    display: flex;
    justify-content: space-between;
    h3 {
      height: 31px;
      font-size: 24px;
      color: #333333;
    }
    div {
      input {
        width: 276px;
        height: 45px;
        background: #ffffff;
        font-size: 14px;
        color: #b9b9b9;
        margin-right: 12px;
        padding-left: 15px;
      }
      .search {
        width: 100px;
        height: 45px;
        background: #f5f5f5;
        border: 1px solid #dddddd;
      }
      .el-button--primary{
       background: #f5f5f5;
       border-color:#f5f5f5;
       color:#000;
       margin-right: 20px;
       height:40px;
      } 
    }
  }
  .main {
    margin-top: 26px;
  }
}
</style>